import React from 'react';

const MessagesList = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Mensajería</h1>
          <p className="text-gray-600">Sistema de comunicación bidireccional</p>
        </div>
        <button className="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-lg font-medium">
          Nuevo Mensaje
        </button>
      </div>

      {/* Content */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <div className="text-center">
          <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 mb-2">Sistema de Mensajería</h3>
          <p className="text-gray-600 mb-6">Este módulo está en desarrollo. Aquí podrás comunicarte entre profesores, apoderados y estudiantes.</p>
          <div className="text-sm text-gray-500">
            Próximamente: Mensajería interna, notificaciones, historial de conversaciones, adjuntos y más.
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessagesList;